import { render, staticRenderFns } from "./EditProfileForm.vue?vue&type=template&id=dda0c73c&scoped=true"
import script from "./EditProfileForm.vue?vue&type=script&lang=js"
export * from "./EditProfileForm.vue?vue&type=script&lang=js"
import style0 from "./EditProfileForm.vue?vue&type=style&index=0&id=dda0c73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda0c73c",
  null
  
)

export default component.exports